/* eslint-disable no-unused-vars */
import React, {PureComponent} from 'react';
import {fromJS} from 'immutable';
import {  Container, Table, Rating, Header, Icon, Pagination, Statistic, Grid, Button, Loader, Feed, Popup, List, Card, Segment, Sidebar, Menu, Label } from 'semantic-ui-react'
import _ from 'lodash';
import moment from 'moment';
import { MARGIN_LEFT } from './Map'

export default class SessionsList extends PureComponent {

  state = { title: 'huh', sessions: [] }

  // componentDidMount() {
  //
  // }
  //
  // componentDidUpdate(prevProps) {
  //
  // }


  _onSessionClick = (geometry,properties) => {
    this.props.onSessionClickFromList({geometry,properties});
  }

  _onSessionHover = (geometry,properties) => {
    console.log('hover')
    this.props.onSessionHover({geometry,properties});

  }
  _renderRecentSessionItem = () => {

  }

  render() {

    let title = 'huh';
    let mySessions = [];
    let showViews = false;

    const { activeItem, sessions, visibleSessions} = this.props;

    if(activeItem === 'visible-sessions'){
      title = 'Visible on map';
      mySessions = visibleSessions || []
    }
    if(activeItem === 'recent-sessions'){
      title = 'Latest 100';
      mySessions = _.orderBy(sessions,['properties.timestamp'],['desc'])
    }
    if(activeItem === 'best-sessions'){
      title = 'Sorted by Most Views';
      mySessions = _.orderBy(sessions,['properties.views'],['desc']);
      showViews = true;
    }

    // now limit the results to avoid chaos
    // console.log('props',this.props)
    if(mySessions.length > 50)
      mySessions = mySessions.slice(0,40)

      // console.log('l',mySessions.length)

    return (

      <div>
        <Menu.Item>
        <Menu.Header>
          <Header as='h1'><Header.Content>Sessions<Header.Subheader>{title}</Header.Subheader></Header.Content></Header>
        </Menu.Header>



          </Menu.Item>
          {_.map(mySessions, ({properties, geometry}) => {

          const active = this.props.activeFeatureId === properties.id
          return (
            <Menu.Item
              style={{paddingTop: 10,paddingBottom: 10}}
              name={''+properties.id} active={active} as='a'
              key={properties.id}
              onClick={ ()=> this._onSessionClick(geometry,properties) }
              >
              {activeItem === 'recent-sessions' && <RecentItem properties={properties} active={active}/> }
              {activeItem === 'visible-sessions' && <VisibleItem properties={properties} active={active}/> }
              {activeItem === 'best-sessions' && <BestItem properties={properties} active={active}/> }
            </Menu.Item>
          )}

          )}

        </div>

    );

  }
}

const RecentItem = ({properties}) => {

  return (
    <div>
    <div><b>{properties.username}</b></div>
    <div>{moment(properties.timestamp).fromNow()}</div>


    </div>
  )
}

const VisibleItem = ({properties}) => {

  return (
    <div>
    <div><b>{properties.username}</b></div>
    <div>{moment(properties.timestamp).fromNow()}</div>


    </div>
  )
}
const BestItem = ({properties, active}) => {

  return (
    <div>

    {properties.username}
    <Label style={{float: 'right'}} circular color={active ? 'yellow' : 'grey'}> {properties.views}</Label>

    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/pages/Dashboard/v3/sessions-list.js